
class Login extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.delegateElement = new Delegate(this.element);
        this.recoveryForm = this.element.querySelector("#ForgotPass");
        this.loginForm = this.element.querySelector("#logIn");
        this.formattedDate = this.element.querySelector("#formattedDate");
        this.genderInput = this.element.querySelector("#RegisterForm-Gender");

        if (window.location.href.indexOf("recover") != -1){
            this.openRecover();
        }

        this.bindEvents();
    }

    bindEvents() {
        this.delegateElement.on(
            "click",
            '[data-action="toggle-recovery"]',
            this.openRecover.bind(this)
        );
        this.delegateElement.on(
            "click",
            '[data-action="toggle-login"]',
            this.openLogin.bind(this)
        );
        this.delegateElement.on(
          "change",
          '[data-action="change-format"]',
          this.changeFormat.bind(this)
        );
        this.delegateElement.on(
          "click",
          '[data-action="change-format"]',
          (e) => e.target.showPicker()
        );
        this.delegateElement.on(
          "change",
          '[data-action="update-gender"]',
          this.updateGender.bind(this)
        );
    }
    openRecover() {
        if(event) event.preventDefault();
        this.recoveryForm.setAttribute('aria-hidden','false');
        this.loginForm.setAttribute('aria-hidden','true');
    }
    openLogin() {
        event.preventDefault();
        this.recoveryForm.setAttribute('aria-hidden','true');
        this.loginForm.setAttribute('aria-hidden','false');
    }
    changeFormat(e) {
      const selectedDate = new Date(e.target.value);
      const day = selectedDate.getDate();
      const month = selectedDate.getMonth() + 1;
      const year = selectedDate.getFullYear();

      const formattedDate = `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`;
      this.formattedDate.value = formattedDate;
      this.updateGender()
    }
    updateGender(e) {
      if(e) this.genderInput.value = this.formattedDate.value + ',' + e.target.value;
      else this.ginderInput.value = this.formattedDate.value + ',' + this.element.querySelector('#genders').value;
    }
}
customElements.define("customer-login", Login);


class AccountComponent extends HTMLElement {
    constructor() {
      super();
      this.element = this;
      this.delegateElement = new Delegate(this.element);
      
      new Popup(this.element);
      if(!this.element.querySelector('[data-subscription="true"]') && this.element.querySelector('.appstle_manageSubBtn')){
        this.element.querySelector('.appstle_manageSubBtn').style.display = "none";
      }
      this.bindEvents();
      this.handleRefreshState();
  
    }
    bindEvents(){
        this.delegateElement.on('click', '[data-action="toggle-subtab"]', this.toggleSubTab.bind(this));
      this.delegateElement.on('click', '[data-action="toggle-tab"]', this.toggleTab.bind(this));
      this.delegateElement.on('click', '[data-action="toggle-back"]', this.toggleBack.bind(this));
      this.delegateElement.on(
        "click",
        '[data-action="delete-address"]',
        this.deleteAddress.bind(this)
    );
  }

  handleRefreshState(){
        this.element.querySelector('#contactInfo').setAttribute('aria-hidden','true');
        // Get the URL search parameters
        var searchParams = new URLSearchParams(window.location.search);

        // Get the value of param1
        var param1Value = searchParams.get('location');

        // Check if param1 has a value
        if (param1Value) this.toggleTab(false, param1Value);
  }
  
  deleteAddress(event) {
    event.preventDefault();
    const id = event.target.getAttribute("data-id");
  
    Shopify.postLink("/account/addresses/" + id, {
        parameters: { _method: "delete" },
    });
  }
  
  toggleBack(){
  
    const allContent = this.element.querySelectorAll('.customerAccount--Content');
      allContent.forEach((content) => {
      if(content.id == "activeOrders" || content.id == "orderHistory") return;
      content.setAttribute('aria-hidden', 'false');
    });
  }
  
  toggleTab(event, paramValue){
    let id = paramValue;
    if (event){
       id = event.target.dataset.id;
    }
   
    const allTabs = this.element.querySelectorAll('.customerAccount--MenuTab[aria-expanded="true"]');
    const allTabsFR =  this.element.querySelectorAll('.customerAccount--MenuTab');
    const allContent = this.element.querySelectorAll('.customerAccount--Content');

    allTabs.forEach((tab) => {
      tab.setAttribute('aria-expanded', 'false');
    });

    allTabsFR.forEach((tab) => {
      if (event){
        if(tab.getAttribute('data-id') == id) tab.setAttribute('aria-expanded', 'true');
      } else {
        const targetEl = this.element.querySelector(`[data-id="${id}"]`)
        if(tab.getAttribute('data-id') == targetEl.getAttribute('data-id')) tab.setAttribute('aria-expanded', 'true');
      }
    });

    if (event){
      event.target.setAttribute('aria-expanded', 'true');
    } else {
      this.element.querySelector(`[data-id="${id}"]`).setAttribute('aria-expanded', 'true');
    }

  
    allContent.forEach((content) => {
      if (!content.classList.contains('customerAccount--ContentOrders')){
        content.setAttribute('aria-hidden', 'false');
      }

    });
  
    const content = this.element.querySelector(`#${id}`);
    if (content) {
      content.setAttribute('aria-hidden', 'true');
    } 

 // Get the current URL
var currentUrl = window.location.href;

// Create a new URL with updated search parameters
var newUrl = currentUrl.split('?')[0] + `?location=${id}`;

// Modify the URL without refreshing the page
window.history.pushState({ path: newUrl }, '', newUrl);

  }

    
  toggleSubTab(event){
  
    const id = event.target.dataset.id;
    const allTabs = this.element.querySelectorAll('.customerAccount--toggleTab[aria-expanded="true"]');
    const allContent = this.element.querySelectorAll('.customerAccount--ContentOrders');

  
 
    allTabs.forEach((tab) => {
      tab.setAttribute('aria-expanded', 'false');
    });
  
    event.target.setAttribute('aria-expanded', 'true');
  
    allContent.forEach((content) => {
      content.setAttribute('aria-hidden', 'false');
    });
  
    const content = this.element.querySelector(`#${id}`);
    if (content) {
      content.setAttribute('aria-hidden', 'true');
    } 
  }
  }
  
  
  customElements.define("account-component-inner", AccountComponent);

  class AccountMenu extends HTMLElement {
    constructor() {
      super();
      this.element = this;
      this.carouselElement = this.element.querySelector(".swiper");
      this.carousel = new RevolutionSwiper(this.carouselElement);
    }
  }
  customElements.define("customer-account-menu", AccountMenu);